"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISCLAIMERS_CATEGORY_KEY = 'overview';
exports.DISCLAIMERS_COMPONENT_KEY = 'disclaimers';